import { APP_BASE_HREF, PlatformLocation } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { LocalStorageService } from "@indusoft/angular-base-services";
import { ProgressSpinnerModule } from "@indusoft/progress-spinner";
import { ToastComponent } from "@indusoft/toast";
import { BaseComponent, ThemeSwitchService } from "@indusoft/angular-base";
import { TooltipDirective } from "@indusoft/tooltip";

import { IndusoftUIInteractionService } from "../../common/services/indusoft-ui-interaction-service";
import { AuthRoutingModule } from "../auth.routing.module";
import { AuthComponent } from "./components/auth.component";
import { ConfigurationHttpService } from "../../common/services/configuration.service";
import { AuthHttpService } from "./services/auth/auth-http.service";
import { AuthStore } from "./store/auth.store";
import { ThemeStore } from "../../common/store/theme.store";
import { BaseRouteInterceptor } from '../../common/core/base-route.interceptor';

@NgModule({
    declarations: [AuthComponent],
    imports: [
        BrowserModule,
        BaseComponent,
        ToastComponent,
        FormsModule,
        ProgressSpinnerModule,
        AuthRoutingModule,
        TooltipDirective
    ],
    providers: [
        {
            provide: APP_BASE_HREF,
            useFactory: getBaseHref,
            deps: [PlatformLocation]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BaseRouteInterceptor,
            multi: true,
        },
        ThemeStore,
        ThemeSwitchService,
        AuthStore,
        AuthHttpService,
        IndusoftUIInteractionService,
        ConfigurationHttpService,
        LocalStorageService
    ],
    bootstrap: [AuthComponent]
})
export class AuthModule {

}

export function getBaseHref(platformLocation: PlatformLocation): string {
    return platformLocation.getBaseHrefFromDOM();
}